import Category from './category/Category'
import AdjustInventory from './inventory/components/AdjustInventory'
import InventoryItems from './inventory/components/InventoryItems'
import InventoryLifecycle from './inventory/components/InventoryLifecycle'
import InventoryUploads from './inventory/components/subcomponents/InventoryUpload'
import UploadHistoryDetails from './inventory/components/subcomponents/UploadHistoryDetails'
import WarehouseWiseInventory from './inventory/components/WarehouseWiseInventory'
import Inventory from './inventory/Inventory'
import WarehouseView from './inventory/WarehouseView'
import WarehouseTransferRequest from '../warehouseTransfer/WarehouseTransferRequest'
import ProductDetail from './product/components/ProductDetail'
import ProductForm from './product/components/ProductForm'
import Product from './product/Product'
import PurchaseEdit from './purchase/details/components/PurchaseEdit'
import PurchaseDetail from './purchase/details/PurchaseDetail'
import Purchase from './purchase/Purchase'
import Supplier from './supplier/Supplier'

export const ROUTES = [
  {
    component: WarehouseView,
    isPublic: true,
    path: '/inventory',
    slug: 'Inventory',
    title: 'Inventory',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },

  {
    component: WarehouseWiseInventory,
    isPublic: true,
    path: '/inventory/warehouse-wise',
    slug: 'Inventory',
    title: 'Inventory',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: InventoryLifecycle,
    isPublic: true,
    path: '/inventory/cycle',
    slug: 'Inventory',
    title: 'Inventory cycle',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Supplier,
    isPublic: true,
    path: '/inventory/suppliers',
    slug: 'supplier',
    title: 'Supplier',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Purchase,
    isPublic: true,
    path: '/inventory/purchases',
    slug: 'purchase',
    title: 'Purchase',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PurchaseDetail,
    isPublic: true,
    path: '/inventory/purchases/detail/:id',
    slug: 'purchase-details',
    title: 'Purchase Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Category,
    isPublic: true,
    path: '/inventory/categories',
    slug: 'category',
    title: 'Category',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Product,
    isPublic: true,
    path: '/inventory/products',
    slug: 'product',
    title: 'Product',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ProductDetail,
    isPublic: true,
    path: '/inventory/products/detail/:id',
    slug: 'product',
    title: 'Product',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: InventoryUploads,
    isPublic: true,
    path: '/inventory/uploads',
    slug: 'uploads',
    title: 'Upload',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: UploadHistoryDetails,
    isPublic: true,
    path: '/inventory/uploads/detail/:id',
    slug: 'upload-details',
    title: 'Upload Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ProductDetail,
    isPublic: true,
    path: '/inventory/uploads/detail/:id',
    slug: 'upload-details',
    title: 'Upload Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ProductForm,
    isPublic: true,
    path: '/inventory/products/new',
    slug: 'product',
    title: 'Product',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ProductForm,
    isPublic: true,
    path: '/inventory/products/edit/:id',
    slug: 'product',
    title: 'Product',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Inventory,
    isPublic: true,
    path: '/inventory',
    slug: 'inventory',
    title: 'Inventory',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: InventoryItems,
    isPublic: true,
    path: '/inventory/details/:id',
    slug: 'inventory-details',
    title: 'Inventory Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: AdjustInventory,
    isPublic: true,
    path: '/inventory/edit',
    slug: 'inventory-details',
    title: 'Inventory Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PurchaseEdit,
    isPublic: true,
    path: '/inventory/purchases/:id',
    slug: 'purchase-details',
    title: 'Purchase Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PurchaseEdit,
    isPublic: true,
    path: '/inventory/purchases/new',
    slug: 'purchase-details',
    title: 'Purchase Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PurchaseEdit,
    isPublic: true,
    path: '/inventory/purchases/:id/edit',
    slug: 'purchase-details',
    title: 'Purchase Details',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: WarehouseTransferRequest,
    isPublic: true,
    path: '/inventory/warehouse-transfer',
    slug: 'warehouse-transfer',
    title: 'Warehouse Transfer',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
]
